var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSmile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 31,
  height: 24,
  fill: "none",
  viewBox: "0 0 31 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#D9D9D9",
  strokeWidth: 4,
  d: "M1.14 17.315c7.75 5.38 21.283 5.03 28.54-.127"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 23.581,
  cy: 4.5,
  r: 4.5,
  fill: "#D9D9D9"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.582,
  cy: 4.5,
  r: 4.5,
  fill: "#D9D9D9"
})));
export default SvgSmile;